import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackText from "../Input/FeedbackText";
import { ErrorMessage } from "./ErrorMessage";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question8FlashCoachExperience = ({
  easeOfNavigationFeedback,
  updateFormData,
  onEnterKeyPress,
  validationError,
}) => {
  return (
    <>
      <FeedbackFormLayout
        title={"Experience with FLASH Coach"}
        subtitle={
          "Tell us about your experience using the platform and what you’d improve."
        }
      >
        <FeedbackHeader
          title={
            "Please provide more details about what exactly led to your rating.*"
          }
        />
        <FeedbackText
          inputID={"easeOfNavigationFeedback"}
          inputText={easeOfNavigationFeedback}
          updateFormData={updateFormData}
          onEnterKeyPress={onEnterKeyPress}
          placeHolder={"E.g. cluttered design, messages were unclear"}
        />
        {validationError?.error && (<ErrorMessage text={validationError.error} />)}

      </FeedbackFormLayout>
    </>
  );
};
